import React, { useContext } from 'react';
import { Render } from '../lib/render';
import { defaultConfig } from '../lib/default-ui-config';
import DyteClient from '@dytesdk/web-core';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';

import { extendConfig } from '../utils/config';
import { States } from '../types/props';
import { UIConfig } from '../types/ui-config';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  config = defaultConfig,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  size = 'sm',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  variant = 'solid',
  states,
  iconPack,
  t,
}: {
  meeting: DyteClient;
  config?: UIConfig;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  variant?: 'boxed' | 'solid';
  iconPack?: IconPack;
  states?: States;
  t?: DyteI18n;
}) {
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  states = states ?? storeStates;
  const customConfig = extendConfig(
    {
      styles: {
        'dyte-controlbar.sm': {
          backgroundColor: colors.background[800],
        },
      },
    },
    defaultConfig
  );
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  return (
    <Render
      element="dyte-controlbar"
      defaults={{
        config: customConfig,
        meeting,
        states: states,
        size: 'sm',
        iconPack: iconPack,
        t: t,
      }}
    />
  );
}
